import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";

type props = {
  text?: string;
  onPress: () => void;
  btnStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  disabled?: boolean;
};

export const Button: React.FC<props> = ({
  text,
  onPress,
  btnStyle,
  textStyle,
  disabled,
}) => {
  return (
    <div
      onClick={disabled ? undefined : onPress}
      style={{
        backgroundColor: "white",
        borderRadius: 100,
        width: 69,
        height: 34,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: disabled ? 0.5 : 1,
        ...btnStyle,
      }}>
      <TCText
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: Colors.darkBrown,
          ...textStyle,
        }}
        value={text ?? "Yes"}
      />
    </div>
  );
};
